import {
  Header1,
  Instruction,
  InstructionWithButtonGroup,
  InstructionWithContent,
} from "../../BlockComponent";
import { ButtonGroup, GuideTypographyLine } from "../../CellComponent";
import { LastCard } from "../common";

export const Content_11_1_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  Instruction("typography_2"),
  Instruction("typography_3"),

  InstructionWithButtonGroup(
    "typography_4",
    [
      { text: "과거에 대한 끝없는 후회" },
      { text: "아직 오지 않은 미래에 대한 불안" },
      { text: "현재 처한 상황에 대한 원망" },
      { text: "잘 모르겠다 (이제부터 알아가 볼 예정)" },
    ],
    { id: "autopilot_path", vertical: true }
  ),

  Header1("typography_5"),
  Instruction("typography_6"),
  Instruction("typography_7"),
  Instruction("typography_8"),
  Instruction("typography_9"),

  Header1("typography_10"),
  Instruction("typography_11"),
  Instruction("typography_12"),

  InstructionWithButtonGroup(
    "typography_13",
    [
      { text: "0-3개" },
      { text: "4-7개" },
      { text: "8-10개" },
      { text: "11개 이상" },
    ],
    { id: "thought_count" }
  ),

  Header1("typography_14"),
  Instruction("typography_15"),
  Instruction("typography_16"),
  Instruction("typography_17"),
  Instruction("typography_18"),

  Header1("typography_19"),
  Instruction("typography_20"),
  Instruction("typography_21"),
  Instruction("typography_22"),
  Instruction("typography_23"),

  InstructionWithContent(`typography_24`, [
    [
      ButtonGroup(
        [
          { text: "A. 회피와 억압" },
          { text: "B. 경험 분리와 주의 통제" },
          { text: "C. 긍정 주입과 이완" },
        ],
        { id: "quiz", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz", answerIndex: 1 }],
    }),
  ]),

  Instruction("typography_25"),

  ...LastCard,
];
